
import { SubRoom } from '@/utils/models';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { parse } from 'json5';

@Component({ components: {} })
export default class SubRoomPresenter extends Vue {
  @Prop()
  subRoom!: SubRoom;
  @Prop()
  isHover!: boolean;
  get subroomStyle(): any {
    let roomstyle: any = {};
    try {
      if (this.subRoom.areaStyle) {
        roomstyle = parse(this.subRoom.areaStyle);
      }
    } catch (e) {}

    const { topLeft, bottomRight } = this.subRoom;
    return {
      ...roomstyle,
      top: topLeft.y + 'px',
      left: topLeft.x + 'px',
      height: bottomRight.y - topLeft.y + 'px',
      width: bottomRight.x - topLeft.x + 'px',
    };
  }
  get nameStyle() {
    return this.subRoom.nameStyle;
  }
  get subroomNameStyle(): any {
    try {
      if (this.nameStyle) {
        return parse(this.nameStyle);
      }
    } catch (e) {}
    return {};
  }
  get isHoverSubroom(): boolean {
    return this.isHover;
  }
}
